import type { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { type BillingMethodListItemViewModel } from '@/features/billing/payment-methods/BillingMethodListItemViewModel'
import { BillingMethodListItem } from '@/features/billing/components/BillingMethodList'

export interface BillingMethodListItemContainerProps {
  vm: BillingMethodListItemViewModel
  onPress?: () => unknown
  /**
   * Shows the delete action when given.
   */
  onDelete?: () => unknown
  isDisabled?: boolean
  dropdownActions?: ReactNode
  testId?: string
}

export const BillingMethodListItemContainer = observer(
  function BillingMethodListItemContainer({
    vm,
    onPress,
    onDelete,
    isDisabled,
    dropdownActions,
    testId,
  }: BillingMethodListItemContainerProps) {
    return (
      <BillingMethodListItem
        billingMethod={vm.displayData}
        selected={vm.isSelected}
        onPress={onPress}
        onDelete={onDelete}
        isDisabled={isDisabled || vm.isBusy}
        isPending={vm.isBusy}
        dropdownActions={dropdownActions}
        testId={testId}
      />
    )
  },
)
